import BookmarkAddRoundedIcon from "@mui/icons-material/BookmarkAddRounded";
import BookmarkRemoveRoundedIcon from "@mui/icons-material/BookmarkRemoveRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { Box, Button, Typography } from "@mui/material";

import { TakeoverView } from "@/pages/takeover/Takeover.types";
import { useTranslation } from "@/translations";

interface Props {
  view: TakeoverView;
  markableCount: number;
  removableCount: number;
  isBusy: boolean;
  onMark: () => void;
  onRemove: () => void;
  onHistoryClick: () => void;
}

/** Page header: title, the bulk actions of the release tab, and the history action ("Geschichte"). */
export function TakeoverHeader({
  view,
  markableCount,
  removableCount,
  isBusy,
  onMark,
  onRemove,
  onHistoryClick,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
      <Typography variant="h1">{t("takeover.title")}</Typography>
      <Box display="flex" alignItems="center" gap={1}>
        {view === "toRelease" && (
          <>
            <Button
              variant="outlined"
              startIcon={<BookmarkAddRoundedIcon />}
              disabled={isBusy || markableCount === 0}
              onClick={onMark}
            >
              {t("takeover.actions.markSelected", { value: markableCount })}
            </Button>
            <Button
              variant="outlined"
              color="error"
              startIcon={<BookmarkRemoveRoundedIcon />}
              disabled={isBusy || removableCount === 0}
              onClick={onRemove}
            >
              {t("takeover.actions.unmarkSelected", { value: removableCount })}
            </Button>
          </>
        )}
        <Button variant="outlined" startIcon={<HistoryRoundedIcon />} onClick={onHistoryClick}>
          {t("takeover.buttons.history")}
        </Button>
      </Box>
    </Box>
  );
}
